module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "IndexTop10"
  }, [(_vm.screenWidth > 1200) ? _c('div', {
    staticClass: "desktop-top10"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "top10"
  }, [_c('img', {
    staticClass: "top-title",
    attrs: {
      "src": require("../assets/images/d-index-top10-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top10-container"
  }, _vm._l((_vm.currentVoteData), function(product, index) {
    return _c('div', {
      key: product.id,
      staticClass: "product-item",
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(product.image) + ')'
      })
    }, [_c('div', {
      staticClass: "class"
    }, [_c('h2', {
      staticClass: "class-name"
    }, [_vm._v(_vm._s(_vm.matchClass(index + 1, 'chiName')))]), _vm._v(" "), _c('p', {
      staticClass: "class-name-eng"
    }, [_vm._v(_vm._s(_vm.matchClass(index + 1, 'engName')))])]), _vm._v(" "), _c('div', {
      staticClass: "pd-cover"
    }, [_c('h3', {
      staticClass: "pd-cover-class-name"
    }, [_vm._v(_vm._s(_vm.matchClass(index + 1)))]), _vm._v(" "), _c('div', {
      staticClass: "pd-content"
    }, [_c('p', {
      staticClass: "pd-brand-name"
    }, [_vm._v(_vm._s(product.brand))]), _vm._v(" "), _c('p', {
      staticClass: "pd-pd-name"
    }, [_vm._v(_vm._s(product.product))])]), _vm._v(" "), _c('router-link', {
      staticClass: "pd-btn-vote",
      attrs: {
        "to": {
          path: '/Popular/result'
        }
      }
    }, [_vm._v("看更多")])], 1)])
  })), _vm._v(" "), _c('div', {
    staticClass: "top10-btn-container"
  }, [_c('router-link', {
    staticClass: "common-btn",
    attrs: {
      "to": "/Popular/info"
    }
  }, [_vm._v("活動辦法"), _c('img', {
    staticClass: "btn-arrow",
    attrs: {
      "src": require("../assets/images/d-btn-arrow.png"),
      "alt": ""
    }
  })])], 1)])]) : _c('div', {
    staticClass: "mobile-top10"
  }, [_vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "top10"
  }, [_c('img', {
    staticClass: "top-title",
    attrs: {
      "src": require("../assets/images/m-index-top10-title.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top10-container"
  }, _vm._l((_vm.currentVoteData), function(product, index) {
    return _c('div', {
      key: product.id,
      staticClass: "product-item",
      class: {
        right: ((index + 1) % 2 == 0), left: ((index + 1) % 2 != 0)
      },
      style: ({
        backgroundImage: 'url(' + _vm.setImageUrl(product.image) + ')'
      })
    }, [_c('div', {
      staticClass: "product-item-cover"
    }), _vm._v(" "), _c('div', {
      staticClass: "class-content"
    }, [_c('h2', {
      staticClass: "class-name"
    }, [_vm._v(_vm._s(_vm.matchClass(index + 1, 'chiName')))]), _vm._v(" "), _c('p', {
      staticClass: "class-name-eng"
    }, [_vm._v(_vm._s(_vm.matchClass(index + 1, 'engName')))])]), _vm._v(" "), _c('div', {
      staticClass: "pd-content"
    }, [_c('p', {
      staticClass: "pd-brand-name"
    }, [_vm._v(_vm._s(product.brand))]), _vm._v(" "), _c('p', {
      staticClass: "pd-pd-name"
    }, [_vm._v(_vm._s(product.product))])]), _vm._v(" "), _c('router-link', {
      staticClass: "pd-btn-vote",
      attrs: {
        "to": {
          path: '/Popular/result'
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "top10-btn-container"
  }, [_c('router-link', {
    staticClass: "common-btn",
    attrs: {
      "to": "/Popular/info"
    }
  }, [_vm._v("活動辦法"), _c('img', {
    staticClass: "btn-arrow",
    attrs: {
      "src": require("../assets/images/d-btn-arrow.png"),
      "alt": ""
    }
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "kv"
  }, [_c('div', {
    staticClass: "kv-scroll page-scroll-kv",
    attrs: {
      "href": ".top10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "kv"
  }, [_c('div', {
    staticClass: "kv-scroll page-scroll-kv",
    attrs: {
      "href": ".top10"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49885025","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexTop10.vue
// module id = 151
// module chunks = 0